import { graphql, useStaticQuery } from 'gatsby'

export const useHeaderImagesMedium = () => {
    const images = useStaticQuery(
        graphql`
            query HeaderImagesMedium {
                allImageSharp {
                    edges {
                        node {
                            gatsbyImageData(height: 30, layout: FIXED)
                            parent {
                                ... on File {
                                    name
                                    ext
                                }
                            }
                        }
                    }
                }
            }
        `
    )
    // noinspection JSUnresolvedVariable
    return images.allImageSharp.edges
}
